// extracted by mini-css-extract-plugin
export default {"switch":"CheckBlock_switch__5-Ipb","block":"CheckBlock_block__JLp2g","margin":"CheckBlock_margin__EVzpJ"};